<template>
  <div class="upload-compoment">
    <div class="sdk-upload-contianer" v-if="tableData.length == 0">
      <div class="sdk-upload" @click="openFolder">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text"><em>点击上传</em></div>
        <div class="el-upload__text" style="padding-top:10px" slot="tip">{{tips}}</div>
      </div>
    </div>
    <el-table
      v-if="tableData.length > 0"
      :data="tableData"
    >
      <el-table-column
        prop="name"
        label="文件名称"
        header-align="center"
        width="200"
      >
        <template slot-scope="scope">
          <p class="file-name"><strong>{{scope.row.name}}</strong></p>
          <p class="file-size">{{scope.row.size | transferFileSize}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="percent"
        label="状态"
        header-align="center"
      >
        <template slot-scope="scope">
          <p class="upload-info">
            <span class="font-info">{{scope.row.status | transferSdkText}}</span>
            <span class="font-info speed" v-if="scope.row.status == 1 || scope.row.status == 0">{{scope.row.speed | transferSpeed}}</span>
          </p>
          <el-progress :stroke-width="10" :percentage="scope.row.percent" :status="transferStatue(scope.row.status)"></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <!--
            status 0:处于计算等待中  1: 传输中  2: 出现异常  3: 完成  4: 暂停 7:取消  10 远端文件不存在
          -->
          <el-button type="text" v-if="scope.row.status == 4" @click="continueTask(scope.row, scope.$index)">开始</el-button>
          <el-button type="text" v-if="scope.row.percent != 100 && (scope.row.status == 0 || scope.row.status == 1)" @click="stopTask(scope.row, scope.$index)">暂停</el-button>
          <el-button type="text" v-if="scope.row.status == 2" @click="continueTask(scope.row, scope.$index)">重试</el-button>
          <el-button type="text" class="font-danger" @click="deleteTask(scope.row, scope.$index)">{{scope.row.percent == 100 ? '删除' : '取消'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
// import { startTask, stopTask, continueTask, deleteTask } from '@/resource/api'
import { setUser, getTaskList, checkSDK, openFolder, startTask, continueTask, stopTask, deleteTask, getDownloadSDK } from '@/resource/api'
import { detectOS } from '@/utils'
const cryptico = require('cryptico.js')
export default {
  name: 'uploadFile',
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    tips: {
      type: String,
      default: '只能上传音/视频文件'
    }
  },
  data () {
    return {
      folderOpen: false,
      limit: 0,
      isSetUser: false,
      sign: `${this.userInfo.userId}|${this.userInfo.userName}`,
      appId: '$newtv',
      timer: null,
      client: null,
      tempIndex: null,
      status: 1,
      tableData: []
    }
  },
  mounted () {
    this.checkSDK()
  },
  methods: {
    setUser () {
      const time = new Date().getTime()
      const userId = this.userInfo.userId
      const userName = this.userInfo.username
      const MattsRSAkey = cryptico.generateRSAKey(`${this.appId}|${time}|${this.sign}`, 1024)
      const sign = cryptico.publicKeyString(MattsRSAkey)
      setUser({
        userId,
        time,
        userName,
        sign
      }).then(res => {
        this.isSetUser = true
        this.getTaskList()
      }).catch(e => {
        this.makeSureAlert()
      })
    },
    checkSDK (cb) {
      checkSDK().then(res => {
        if (!this.isSetUser) {
          this.setUser(cb)
        }
        cb && cb()
      }).catch(e => {
        this.isSetUser = false
        this.makeSureAlert()
      })
    },
    async getTaskList () {
      getTaskList().then(res => {
        let flag = true
        for (let i = 0; i < res.result.docs.length; i++) {
          if (res.result.docs[i].status == 0 || res.result.docs[i].status == 1) {
            flag = false
            break
          }
        }
        if (this.timer && res.result.docs.length == 0) {
          clearInterval(this.timer)
          this.timer = null
          this.tableData = this.tableData.map(item => {
            const path = item.wholePath.split('/').reverse()
            item.percent = 100
            item.status = 3
            item.path = '/' + path[2] + '/' + path[1] + '/' + path[0]
            return item
          })
          this.$emit('complated', this.tableData)
          return false
        }
        if (this.timer && flag) {
          clearInterval(this.timer)
          this.timer = null
          return false
        }
        this.tableData = res.result.docs.map(item => {
          item.percent = parseInt((item.transferSize / item.size).toFixed(2) * 100)
          return item
        })
      }).catch(e => {
        this.sdkError(e)
      })
    },
    sdkError (e) {
      console.log(e.status)
      this.$message.error(e)
    },
    transferStatue (statue) {
      switch (statue) {
        case 2:
          return 'exception'
        case 3:
          return 'success'
      }
    },
    openFolder () {
      if (this.folderOpen || this.limit) return
      this.checkSDK(() => {
        this.folderOpen = true
        openFolder({
          isFile: true, // 文件模式还是文件夹模式，上传使用文件模式，下载使用文件夹模式
          isSimple: true, // 是否支持多选，只对上传使用，即一次性发送多个文件
          suffix: ['mp4', 'ts', 'mov', 'avi', 'rmvb', 'mpg', 'mpeg', 'm4v', 'qt', 'flv', 'wmv', 'asf', 'vob', 'mkv', 'asf', 'wmv', 'rm', 'vob', 'ts', 'dat']
        }).then(res => {
          const { files } = res.result
          if (files.length) {
            this.startTask(files)
          }
          this.folderOpen = false
        })
      })
    },
    startTask (files) {
      this.limit = 1
      const time = new Date().getTime()
      const MattsRSAkey = cryptico.generateRSAKey(`${this.appId}|${time}|${this.sign}`, 1024)
      const sign = cryptico.publicKeyString(MattsRSAkey)
      this.$emit('startUpload')
      startTask({
        appId: this.appId,
        time,
        sign,
        id: `${time}`,
        host: process.env.VUE_APP_SDK_UPLOAD_API,
        files: files.map(item => {
          let fileName = item.name.split('.')
          const ext = fileName.pop()
          fileName = fileName.join().replace(/[\s|_|`|~|!|@|#|$|%|^|&|*|(|)|+|=|||{|}|'|:|;|'|,|[|\]|.|<|>|/|?|~|！|@|#|￥|%|……|&|*|（|）|——|+|||{|}|【|】|‘|；|：|”|“|’|。|，|、|？|\n|\r|\t]/g, '') + '_' + time + '.' + ext
          return {
            ...item,
            relationPath: '/' + this.$moment(time).format('YYYY-MM-DD') + '/' + this.userInfo.userId + '/' + fileName
          }
        })
      }).then(res => {
        this.startInterval()
      })
    },
    startInterval () {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.getTaskList()
        }, 800)
      }
    },
    continueTask (row, index) {
      this.$emit('startUpload', row)
      this.checkSDK(() => {
        continueTask(row._id).then(res => {
          this.tableData[index].status = 0
          this.startInterval()
        })
      })
    },
    stopTask (row, index) {
      this.$emit('pauseUpload', row)
      this.checkSDK(() => {
        stopTask(row._id).then(() => {
          this.tableData[index].status = 4
          this.startInterval()
        })
      })
    },
    deleteTask (row, index) {
      this.checkSDK(() => {
        deleteTask(row._id).then(() => {
          this.tableData.splice(index, 1)
          this.limit = 0
          this.$emit('complated', this.tableData)
        })
      })
    },
    makeSureAlert () {
      this.$confirm('您还没有启动SDK或启动失败，是否启动?', '提示', {
        confirmButtonText: '已下载并启动',
        cancelButtonText: 'SDK下载',
        type: 'warning',
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        beforeClose: (action, instance, done) => {
          switch (action) {
            case 'cancel':
              this.downloadSDK()
              break
            case 'confirm':
              window.location.href = 'newtvsdk://'
              break
            default:
              this.$router.push({ path: '/uploadFile' })
              break
          }
          done()
        }
      })
    },
    async downloadSDK () {
      const { result: { downloadUrl } } = await getDownloadSDK(detectOS())
      window.location.href = downloadUrl
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style lang="less">
  .upload-compoment {
    text-align: center;
    .upload-info {
      margin: 0;
      .speed {
        padding-left: 10px;
      }
    }
    .el-progress__text {
      font-size: 13px!important;
    }
    .file-name, .file-size {
      margin: 0;
    }
    .file-size {
      font-size: 10px;
      color: #999;
    }
    // .sdk-upload-contianer {
    //   margin: 0 auto;
    //   width: 600px;
    // }
    .sdk-upload {
      width: 900px;
      height: 224px;
      border-radius: 6px;
      cursor: pointer;
      border: none;
      margin: 0 auto;
      &:hover {
        border-color: #7F63F2;
      }
      .el-icon-upload {
        font-size: 67px;
        color: #C0C4CC;
        margin: 23px 0 16px;
        line-height: 50px;
        box-sizing: border-box;
      }
      .el-upload__text{
        color: #606266;
        font-size: 14px;
        text-align: center;
        em {
          font-style: normal;
          color: #7F63F2;
        }

      }
    }
  }
</style>
